"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHead = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const _1 = require("./");
class TableHead extends React.Component {
    constructor() {
        super(...arguments);
        this.documentBody = document.body;
        this.headerCellRefs = {};
        this.state = {
            visibleColumnFilter: '',
        };
        this.addHeaderCellRef = (cellName, node) => {
            if (node) {
                this.headerCellRefs[cellName] = node;
            }
        };
        this.handleClick = (e) => {
            const { tableWrapperRef } = this.props;
            const { visibleColumnFilter } = this.state;
            const withinTable = $(tableWrapperRef.current).has(e.target).length > 0;
            const $target = $(e.target);
            if (visibleColumnFilter &&
                ((withinTable && !$target.parents().hasClass('column-filter')) || !withinTable)) {
                this.closeColumnFilter();
            }
        };
        this.handleColumnFilterBtnClick = (e) => {
            let visibleColumnFilter = e.target.getAttribute('data-filter-group') || '';
            visibleColumnFilter =
                this.state.visibleColumnFilter !== visibleColumnFilter ? visibleColumnFilter : '';
            this.setState({ visibleColumnFilter });
            this.props.onFilterGroupChange(visibleColumnFilter);
        };
        this.closeColumnFilter = () => {
            this.setState({ visibleColumnFilter: '' });
        };
        this.getHeaderDetails = (cellName) => {
            const headerCellRef = this.headerCellRefs[cellName];
            if (!headerCellRef) {
                return { width: null, height: null, left: null };
            }
            const tableWrapperEl = this.props.tableWrapperRef.current;
            const tableScrollLeft = tableWrapperEl ? tableWrapperEl.scrollLeft : 0;
            return {
                height: headerCellRef.offsetHeight,
                left: headerCellRef.offsetLeft - tableScrollLeft,
                width: headerCellRef.offsetWidth,
            };
        };
    }
    componentDidMount() {
        this.documentBody.addEventListener('mousedown', this.handleClick);
    }
    componentWillUnmount() {
        this.documentBody.removeEventListener('mousedown', this.handleClick);
    }
    render() {
        const { selectedFilters, filters, resetFilterLabel, sortOrder, sortColumn, onFilterChange, handleColumnHeaderClick, tableWrapperRef, tableAriaLiveRef, isNoData, columns, sortingAriaLabels, onSearchFilterChange, searchInputAriaLabel, } = this.props;
        const { visibleColumnFilter } = this.state;
        return ((0, jsx_runtime_1.jsx)("thead", { className: "bg-surface-secondary text-left max-sm:sr-only", children: (0, jsx_runtime_1.jsx)("tr", { className: "border-b-sm border-secondary h-[44px]", children: columns.map((cell, cellIndex, cellArr) => {
                    return ((0, jsx_runtime_1.jsx)(_1.TableHeadCell, { cellInfo: cell, cellIndex: cellIndex, cellsCount: cellArr.length, selectedFilters: selectedFilters, filters: filters, resetFilterLabel: resetFilterLabel, visibleColumnFilter: visibleColumnFilter, sortOrder: sortOrder, sortColumn: sortColumn, closeColumnFilter: this.closeColumnFilter, onFilterChange: onFilterChange, onSearchFilterChange: onSearchFilterChange, addHeaderCellRef: this.addHeaderCellRef.bind(this, cell.name), handleColumnHeaderClick: handleColumnHeaderClick, handleColumnFilterBtnClick: this.handleColumnFilterBtnClick, tableWrapperRef: tableWrapperRef, tableAriaLiveRef: tableAriaLiveRef, getHeaderDetails: this.getHeaderDetails, isNoData: isNoData, sortingAriaLabels: sortingAriaLabels, searchInputAriaLabel: searchInputAriaLabel }, cellIndex));
                }) }) }));
    }
}
exports.TableHead = TableHead;
